import React, { useCallback, useEffect, useState } from 'react'

// Redux ----------------------------------------
import { useDispatch, useSelector } from 'react-redux'
import { recentDraftListPath } from '../../services/config'
import { ancemntNotification, initNotification } from '../../redux/slices/announcementSlice'


const AnnouncemntTemplate = ({ selectTemplate }) => {
    const userData = JSON.parse(localStorage.getItem("user_data")) || {}

    const dispatch = useDispatch()
    const anStore = useSelector((state) => state.announce)

    const [templateLise, setTemplateList] = useState([])

    // Get template list functions are here ------------------
    const getTemplateList = useCallback(() => {
        const formData = {
            path: recentDraftListPath,
            data: {
                "userId": userData.user_id,
                "isDraft": "2"
            }
        }
        dispatch(ancemntNotification(formData))
    }, [])

    useEffect(() => { getTemplateList() }, [])
    useEffect(() => {
        if (anStore.ancemntNotificationSuccess) {
            setTemplateList(anStore.ancemntNotificationData)
            dispatch(initNotification())
        }
    }, [anStore])

    return (
        <>
            <h3 className="color-white">Announcement Templates</h3>
            <span className="color-gray mb-3 font-14 ">Pre-designed templates to get you started quickly</span>

            <div className="completed-announcement mt-4 mb-5">
                {
                    templateLise?.map((item) => {
                        return <div className={"announcement-item festival"} key={item}>

                            <div className="space-center">
                                <span className="icon font-20"><img src={"festival"} /></span>
                                <h4 className="font-17">Festival</h4>
                                <h5 className="font-weight-200">Celebrate holidays</h5>
                            </div>

                            <div className="space-between">
                                <span className="color-gray font-14">Used:</span>
                                <span className="color-gray font-14">24 times</span>
                            </div>
                            <div className="space-between">
                                <span className="color-gray font-14">Last Updated:</span>
                                <span className="color-gray font-14">2 days ago</span>
                            </div>
                            <button className="festival-btn mt-2" onClick={() => selectTemplate(item)}>Use Template</button>
                        </div>
                    })
                }



                {/* <div className={"announcement-item festival"}>

                    <div className="space-center">
                        <span className="icon font-20"><img src={"festival"} /></span>
                        <h4 className="font-17">Festival</h4>
                        <h5 className="font-weight-200">Celebrate holidays</h5>
                    </div>

                    <div className="space-between">
                        <span className="color-gray font-14">Used:</span>
                        <span className="color-gray font-14">24 times</span>
                    </div>
                    <div className="space-between">
                        <span className="color-gray font-14">Last Updated:</span>
                        <span className="color-gray font-14">2 days ago</span>
                    </div>
                    <button className="festival-btn mt-2">Use Template</button>
                </div>


                <div className={"announcement-item birthday"}>
                    <div className="space-center mb-1">
                        <span className="icon font-20"><img src={"birthday"} /></span>
                        <h4 className="font-17">Birthday</h4>
                        <h5 className="font-weight-200">Team birthdays</h5>
                    </div>
                    <div className="space-between">
                        <span className="color-gray font-14">Used:</span>
                        <span className="color-gray font-14">24 times</span>
                    </div>
                    <div className="space-between mb-1">
                        <span className="color-gray font-14">Last Updated:</span>
                        <span className="color-gray font-14">2 days ago</span>
                    </div>
                    <button className="birthday-btn mt-2">Use Template</button>
                </div>


                <div className={"announcement-item appreciation"} >

                    <div className="space-center mb-1">
                        <span className="icon font-20"><img src={"star"} /> </span>
                        <h4 className="font-17">Employee Appreciation</h4>
                        <h5 className="font-weight-200">Recognition posts</h5>
                    </div>


                    <div className="space-between">
                        <span className="color-gray font-14">Used:</span>
                        <span className="color-gray font-14">24 times</span>
                    </div>
                    <div className="space-between mb-1">
                        <span className="color-gray font-14">Last Updated:</span>
                        <span className="color-gray font-14">2 days ago</span>
                    </div>

                    <button className="appreciation-btn mt-2">Use Template</button>
                </div>


                <div className={"announcement-item onboarding"} >

                    <div className="space-center mb-1">
                        <span className="icon font-20"><img src={"onbording"} /> </span>
                        <h4 className="font-17">Onboarding</h4>
                        <h5 className="font-weight-200">Welcome new hires</h5>
                    </div>


                    <div className="space-between">
                        <span className="color-gray font-14">Used:</span>
                        <span className="color-gray font-14">24 times</span>
                    </div>
                    <div className="space-between mb-1">
                        <span className="color-gray font-14">Last Updated:</span>
                        <span className="color-gray font-14">2 days ago</span>
                    </div>

                    <button className="onboarding-btn mt-2">Use Template</button>
                </div> */}

            </div>
        </>
    )
}

export default AnnouncemntTemplate